import {NgModule} from '@angular/core';
import {EntityDataService, EntityServices} from '@ngrx/data';
import {Scanner3dConverter} from './api/entity/converter/scanner3d.converter';
import {Scanner3dRepository} from './impl/service/ngrx/scanner3d.repository';
import {Scanner3dDataService} from './impl/service/ngrx/scanner3dData.service';
import {Scanner3dDataServiceAdapter} from './impl/service/ngrx/scanner3dDataService.adapter';
import {Scanner3dFindAllService} from './impl/service/scanner3dFindAll.service';

@NgModule({
    providers: [
        Scanner3dConverter,

        Scanner3dRepository,
        Scanner3dDataService,
        Scanner3dDataServiceAdapter,

        Scanner3dFindAllService,
    ],
})
export class Scanner3dCommonModule {
     constructor(entityDataService: EntityDataService,
                 entityServices: EntityServices,
                 repository: Scanner3dRepository,
                 dataService: Scanner3dDataService,
    ) {

        entityDataService.registerServices({
            Scanner3d: dataService,
        });

        entityServices.registerEntityCollectionServices({
            Scanner3d: repository,
        });

        // errorMessages.set(PARTNER_SAVE_PERSON_ALREADY_PART_OF_THIS_TYPE, 'La personne sélectionnée est déjà %1');
    }
}
